// extracted by mini-css-extract-plugin
export default {"howItWorks":"howItWorks_howItWorks__4ZYTW","cardContent":"howItWorks_cardContent__EPJiJ","secondaryCta":"howItWorks_secondaryCta__gzzfY"};